import { Button } from '@boltenergy-be/design-system'
import { FaqButtonProps } from './types'
import FaqDrawer from 'components/faq-drawer/FaqDrawer'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetLanguage } from 'hooks/use-get-language'
import { useGetFaqByMultipleSlugsQuery } from 'store/queries/cms-api'
import { FaqSlugB2C } from 'types/faq.ts'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import { trackEvent } from 'utils/tracking.ts'

const FaqButton = ({ faqCategories, tagsToHide, isOpen: controlledIsOpen, onOpenChange }: FaqButtonProps) => {
  // i18n
  const { t } = useTranslation('common')
  const language = useGetLanguage()

  // Redux queries
  const { isLoading, data } = useGetFaqByMultipleSlugsQuery(
    {
      language,
      slugs: faqCategories as FaqSlugB2C[]
    },
    {
      skip: !faqCategories?.length
    }
  )

  // Local state
  const [internalFaqOpen, setInternalFaqOpen] = useState<boolean>(false)
  const faqOpen = controlledIsOpen || internalFaqOpen
  const setFaqOpen = (open: boolean) => {
    setInternalFaqOpen(open)
    onOpenChange?.(open)
  }

  return !isLoading && !data?.categories?.length ? null : (
    <>
      {isLoading ? (
        <LoadingSkeleton>
          <LoadingSkeleton.Circle widthHeight={24} />
        </LoadingSkeleton>
      ) : (
        data?.categories?.some((c) => !!c.questions.length) && (
          <Button
            leadingIcon="questionMarkCircle"
            variant="tertiary"
            onClick={() => {
              setFaqOpen(true)
              trackEvent({ category: 'support', object: 'open_faq_drawer', action: 'click' }, { categories: faqCategories })
            }}
          />
        )
      )}

      {!!data?.categories?.length && (
        <FaqDrawer
          isOpen={faqOpen}
          onRequestClose={() => setFaqOpen(false)}
          questions={data.categories.flatMap((cat) => cat.questions)}
          title={t(($) => $.faq.title)}
          hasSearch={false}
          {...{ tagsToHide }}
        />
      )}
    </>
  )
}

export default FaqButton
